import Chip from '@mui/material/Chip';
import './BidRoundChip.scss';

/** @param {import('@mui/material').ChipProps} param0 */
const BidRoundChip = ({ className, label, ...props }) => (
    <Chip
        {...props}
        className={`core--bid-round-chip ${className || ''}`}
        label={label}
    />
);

export default BidRoundChip;
